module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Book-ee8dd388f03b50857b08abd37ed6e3aa.woff2";